/* eslint-disable import/no-unresolved */

import * as CAPTCHA from './CAPTCHA';

export {
  // eslint-disable-next-line import/prefer-default-export
  CAPTCHA,
};
